<template>
  <div class="sessions" v-if="!isEmptySessions && !isEmptyTempChosenResult">
    <div v-if="!isMobile">
      <div class="session" v-for="(session, key, sessionIndex) in sessions">
        <div class="session-info d-flex">
          <div class="col-md-2 px-0 text-left">
            <p>{{'rotation.session' | trans}} {{(sessionIndex + 1)}}</p>
          </div>

          <div class="col-md-8"></div>

          <div class="col-md-2  px-0 text-center">
            <p>{{'rotation.result' | trans}}</p>
          </div>
        </div>

        <div class="session-head d-flex text-center">
          <div class="col-md-1  px-0">
            <p>{{'rotation.block' | trans}}</p>
          </div>
          <div class="col-md-9">
            <div class="row">
              <div class="col-4">
                <p>{{'rotation.L' | trans}}</p>
              </div>
              <div class="col-4">
                <p>{{'rotation.M' | trans}}</p>
              </div>
              <div class="col-4">
                <p>{{'rotation.R' | trans}}</p>
              </div>
            </div>
          </div>
          <div class="col-md-2  px-0">
            <p>'+' '-' '{{'rotation.p' | trans}}'</p>
          </div>
        </div>

        <div class="col-md-12">
          <div class="session-block row" v-for="(block, blockIndex) in session.blocks" :key="blockIndex">
            <div class="col-md-1">
              {{(block.index)}}
            </div>
            <div class="col-md-9">
              <div class="row">
                <div class="col-4 px-0" v-for="(blockCell, index) in block.stimuli" :key="index">
                  <div class="session-block__cell" :class="{'session-block__cell--active' : blockCell.correct}">
                    <p>{{blockCell.name}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="session-block__radios col-md-2">
              <div class="row">
                <div class="col-4 px-0">
                  <label>
                    <input type="radio"
                           v-model="tempChosenResult[sessionIndex][blockIndex].value"
                           :name="'radios[' + sessionIndex + '][' + blockIndex + ']'"
                           :value="successfulAnswer"
                           @click="setChecked(sessionIndex, blockIndex)"
                           :disabled="tempChosenResult[sessionIndex][blockIndex].isChecked">
                    </input>
                    <span class="text big">
                      +
                  </span>
                  </label>
                </div>

                <div class="col-4 px-0">
                  <label>
                    <input type="radio"
                           v-model="tempChosenResult[sessionIndex][blockIndex].value"
                           :name="'radios[' + sessionIndex + '][' + blockIndex + ']'"
                           :value="failAnswer"
                           @click="setChecked(sessionIndex, blockIndex)"
                           :disabled="tempChosenResult[sessionIndex][blockIndex].isChecked">
                    </input>
                    <span class="text big">
                    —
                  </span>
                  </label>
                </div>

                <div class="col-4 px-0">
                  <label>
                    <input type="radio"
                           v-model="tempChosenResult[sessionIndex][blockIndex].value"
                           :name="'radios[' + sessionIndex + '][' + blockIndex + ']'"
                           :value="hintAnswer"
                           @click="setChecked(sessionIndex, blockIndex)"
                           :disabled="tempChosenResult[sessionIndex][blockIndex].isChecked">
                    </input>
                    <span class="text">
                    P
                  </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="session-head d-flex text-center">
        <div class="col-6 text-left px-0">
          <p>{{'rotation.session' | trans}} {{(indexCurrentSession + 1)}}/{{sessionsLength}}</p>
        </div>

        <div class="col-6 text-right  px-0">
          <p>{{'rotation.block' | trans}} {{(indexCurrentBlock + 1)}}/{{blocksLength}}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12" v-for="blockCell in visibleBlock.stimuli">
          <div class="session-block__cell" :class="{'session-block__cell--active' : blockCell.correct}">
            <p>{{blockCell.name | shortText(shortTextLength)}}</p>
          </div>
        </div>

        <div class="session-block__radios col-12">
          <div class="col-12">
            <div class="row">

              <div class="col-4 px-0">
                <label :class="{'is-checked': tempChosenResult[indexCurrentSession][indexCurrentBlock].value == successfulAnswer}">
                  <input type="radio"
                         :id="successfulAnswer"
                         v-model="tempChosenResult[indexCurrentSession][indexCurrentBlock].value"
                         :name="'radios[' + indexCurrentSession + '][' + indexCurrentBlock + ']'"
                         :value="successfulAnswer"
                         @click="setChecked(indexCurrentSession, indexCurrentBlock)"
                         :disabled="tempChosenResult[indexCurrentSession][indexCurrentBlock].isChecked">
                  </input>
                  <span class="text big">
                    +
                  </span>
                </label>
              </div>

              <div class="col-4 px-0">
                <label  :class="{'is-checked': tempChosenResult[indexCurrentSession][indexCurrentBlock].value == hintAnswer}">
                  <input type="radio"
                         v-model="tempChosenResult[indexCurrentSession][indexCurrentBlock].value"
                         :id="hintAnswer"
                         :name="'radios[' + indexCurrentSession + '][' + indexCurrentBlock + ']'"
                         :value="hintAnswer"
                         @click="setChecked(indexCurrentSession, indexCurrentBlock)"
                         :disabled="tempChosenResult[indexCurrentSession][indexCurrentBlock].isChecked">
                  </input>
                  <span class="text">
                    P
                  </span>
                </label>
              </div>

              <div class="col-4 px-0">
                <label  :class="{'is-checked': tempChosenResult[indexCurrentSession][indexCurrentBlock].value == failAnswer}">
                  <input type="radio"
                         :id="failAnswer"
                         v-model="tempChosenResult[indexCurrentSession][indexCurrentBlock].value"
                         :name="'radios[' + indexCurrentSession + '][' + indexCurrentBlock + ']'"
                         :value="failAnswer"
                         @click="setChecked(indexCurrentSession, indexCurrentBlock)"
                         :disabled="tempChosenResult[indexCurrentSession][indexCurrentBlock].isChecked">
                  </input>
                  <span class="text big">
                    —
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>


        <div class="col-12">
          <div class="session-block__pagination d-flex justify-content-between">
            <mdc-button type="submit"
                        class="button-primary col-2 px-0 mt-2"
                        @click="changeBlock('prev')"
                        :disabled="isPrevButtonDisabled">
              <mdc-icon icon="arrow_back_ios"></mdc-icon>
            </mdc-button>

            <mdc-button type="submit"
                        class="button-primary col-9 px-0 mt-2"
                        @click="changeBlock('next')"
                        :disabled="isNextButtonDisabled">
              {{'rotation.next_block' | trans}}
              <mdc-icon icon="arrow_forward_ios"></mdc-icon>
            </mdc-button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 px-0 text-left">
      <mdc-button type="submit"
                  class="button-primary col-sm-6 col-md-7 col-lg-6 col-xl-4 mt-2"
                  @click="showReport()">{{'rotation.show_results' | trans}}
      </mdc-button>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapGetters} from 'vuex';
  import cloneDeep from 'lodash/cloneDeep';
  import isEmpty from 'lodash/isEmpty'
  import Constants from '../Constants';

  export default {
    data() {
      return {
        tempChosenResult: [],
        indexCurrentBlock: 0,
        indexCurrentSession: 0,
        shortTextLength: 150,
      }
    },
    created() {
      this.initChosenResults()
    },
    computed: {
      ...mapState('rotation/session', [
        'sessions',
        'isSaved',
      ]),
      ...mapGetters('mobile', [
        'isMobile'
      ]),
      isEmptySessions: function () {
        return isEmpty(this.sessions)
      },
      isEmptyTempChosenResult: function () {
        return isEmpty(this.tempChosenResult)
      },
      tempSessions() {
        return cloneDeep(this.sessions);
      },
      visibleBlock() {
        return this.sessions[this.indexCurrentSession].blocks[this.indexCurrentBlock];
      },
      sessionsLength() {
        return Object.keys(this.sessions).length;
      },
      blocksLength() {
        return this.sessions[this.indexCurrentSession].blocks.length;
      },
      isPrevButtonDisabled() {
        return (
            this.indexCurrentBlock === 0
            && this.indexCurrentSession === 0
        );
      },
      isNextButtonDisabled() {
        return (
            this.indexCurrentBlock === (this.blocksLength - 1)
            &&
            this.indexCurrentSession === (this.sessionsLength - 1)
        );
      },
      successfulAnswer() {
        return Constants.SUCCESSFUL_ANSWER;
      },
      failAnswer() {
        return Constants.FAIL_ANSWER;
      },
      hintAnswer() {
        return Constants.HINT_ANSWER;
      },
    },
    filters: {
      shortText: function (text, length) {
        if (text.length < length) {
          return text;
        }
        else {
          return text.substr(0, length) + '...';
        }
      }
    },
    methods: {
      ...mapActions('rotation/session', [
        'setSessions',
      ]),
      initChosenResults() {
        this.tempChosenResult = [];
        for (let k = 0; k < Object.keys(this.sessions).length; k++) {

          //set chosenResult as array for each session
          this.$set(this.tempChosenResult, k, []);

          for (let i = 0; i < this.sessions[k].blocks.length; i++) {
            this.$set(this.tempChosenResult[k], i, {
              value: null,
              isChecked: false
            });
          }
        }
      },
      setChecked(sessionIndex, blockIndex) {
        this.tempChosenResult[sessionIndex][blockIndex].isChecked = true;
      },
      refreshResults() {
        this.tempChosenResult = [];
        this.indexCurrentBlock = 0;
        this.indexCurrentSession = 0;
        this.initChosenResults();
      },
      changeBlock(direction) {
        if (direction === 'next') {
          if (this.indexCurrentBlock === (this.blocksLength - 1)) {
            this.indexCurrentSession++;
            this.indexCurrentBlock = 0;
          }
          else {
            this.indexCurrentBlock++;
          }
        }
        else {
          if (this.indexCurrentBlock === 0) {
            this.indexCurrentSession--;
            this.indexCurrentBlock = this.blocksLength - 1;
          }
          else {
            this.indexCurrentBlock--;
          }
        }
      },
      showReport() {
        for (let i = 0; i < Object.keys(this.tempSessions).length; i++) {
          for (let j = 0; j < this.tempSessions[i].blocks.length; j++) {
            if (this.tempChosenResult[i][j].value === Constants.SUCCESSFUL_ANSWER) {
              this.tempSessions[i].blocks[j].resultId = Constants.SUCCESSFUL_ANSWER;
            }
            else if (this.tempChosenResult[i][j].value === Constants.FAIL_ANSWER) {
              this.tempSessions[i].blocks[j].resultId = Constants.FAIL_ANSWER;
            }
            else if (this.tempChosenResult[i][j].value === Constants.HINT_ANSWER) {
              this.tempSessions[i].blocks[j].resultId = Constants.HINT_ANSWER;
            }
          }
        }

        this.setSessions(this.tempSessions);
        this.$emit('show-report');
      },
    },
    watch: {
      isSaved: function () {
        this.refreshResults();
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/modules/randomRotation/components/SessionsList.vue